export const getCurLocale = (lang_code: any) => {
  let locale = "";
  switch (lang_code) {
    case "zh-cn":
      locale = "zh";
      break;
    case "en":
      locale = "en";
      break;
    case "de":
      locale = "de";
      break;
    case "fr":
      locale = "fr";
      break;
    default:
      locale = "zh";
      break;
  }
  return locale;
};

export const getAgentFromScript = (): string => {
  let agent = "";
  // 通过id获取script标签
  const scriptElement = document.getElementById(
    "ai-agent"
  ) as HTMLScriptElement | null;
  if (scriptElement) {
    // 解析查询参数
    const src = scriptElement.src;
    const url = new URL(src);
    agent = url.searchParams.get("agent") || "";
  }
  return agent;
};

//判断是否是手机端
export const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};

//获取站点主题
export const getSiteTheme = (host) => {
  let site = "";
  if (host) {
    switch (host) {
      case host.includes("tenorshare"):
        site = "ts";
        break;
      case host.includes("passfab"):
        site = "pf";
        break;
      case host.includes("niuxuezhang"):
        site = "nxz";
        break;
      case host.includes("nxzsoftware"):
        site = "nxzsoftware";
        break;
      case host.includes("ultfone"):
        site = "ultfone";
        break;
      case host.includes("4ddig"):
        site = "4ddig";
        break;
      case host.includes("hitpaw"):
        site = "hitpaw";
        break;
      case host.includes("blipcut"):
        site = "blipcut";
        break;
      default:
        site = "nxz";
        break;
    }
    return site;
  }
  return site;
};

export const siteServiceLogo = {
  ts: {
    logo: "/images/ts.png",
    aiAvatar: "/avatar/ts.png",
  },
  pf: {
    logo: "/images/passfab.png",
    aiAvatar: "/avatar/passfab.png",
  },
  nxz: {
    logo: "/images/hitpaw.png",
    aiAvatar: "/avatar/hitpaw.png",
  },
  nxzsoftware: {
    logo: "/images/ts.png",
    aiAvatar: "/avatar/ts.png",
  },
  blipcut: {
    logo: "/images/blipcut.png",
    aiAvatar: "/avatar/blipcut.png",
  },
  hitpaw: {
    logo: "/images/hitpaw.png",
    aiAvatar: "/avatar/hitpaw.png",
  },
  ultfone: {
    logo: "/images/ultfone.png",
    aiAvatar: "/avatar/ult.png",
  },
  "4ddig": {
    logo: "/images/ultfone.png",
    aiAvatar: "/avatar/ult.png",
  },
};

//获取当前主域名
export const getTargetUrl = () => {
  let domain = window.location.hostname;
  if (
    domain.includes("test") ||
    domain.includes("localhost") ||
    domain.includes("127.0.0.1")
  ) {
    // 如果包含，则返回指定的 URL
    return "https://ai-agent-test-api.afirstsoft.cn/";
  } else {
    // 如果不包含，则获取当前页面地址的主域并拼接新的 URL
    if (domain.indexOf(".") !== domain.lastIndexOf(".")) {
      domain = domain.substring(domain.indexOf(".") + 1);
    }
    return `https://aics.${domain}`;
  }
};
